const addShareUrls = function() {
  // on page load check for node class
  window.addEventListener('load', function(event) {
    const fbShareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location;
    const twShareUrl = 'https://twitter.com/intent/tweet?text=' + window.location;
    const mailShareUrl = ['mailto:?subject=',
      encodeURI(document.title),
      '&body=',
      window.location,
    ];

    const fel = document.querySelectorAll('.share-facebook');

    if (fel.length > 0) {
      fel.forEach((item) => {
        item.href = fbShareUrl;
      });
    }

    const tel = document.querySelectorAll('.share-twitter');

    if (tel.length > 0) {
      tel.forEach((item) => {
        item.href = twShareUrl;
      });
    }

    const mel = document.querySelectorAll('.share-mail');

    if (mel.length > 0) {
      mel.forEach((item) => {
        item.href = mailShareUrl.join('');
      });
    }
  });
};

export default addShareUrls;
